import { render, staticRenderFns } from "./BlockHero.vue?vue&type=template&id=b4e8cdca&"
import script from "./BlockHero.vue?vue&type=script&lang=js&"
export * from "./BlockHero.vue?vue&type=script&lang=js&"
import style0 from "./BlockHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports